<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-6">
                        <div class="font-weight-bold body-1">
                            Actualizar estatus
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" @submit.prevent="save">
                            <process-form ref="ProcessForm" :values="form" @save="save" :serverErrors="serverErrors"></process-form>
                        </v-form>
                    </v-col>
                    
                </v-row>

            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../../../helpers/Utils';
import ProcessForm from "./ProcessForm.vue";
export default {
    components: {
        'process-form': ProcessForm,
    },
	data(){
		return {
            serverErrors: {},
            loading: false,
            jobId: this.$route.params.jobId,
            candidateId: this.$route.params.candidateId,
            
            form: {
                
                name: 'Ricardo Martín Flores Valdivia',
                step: '',

               

                status:[
                {
                    id: '1',
                    type: 'ENTREVISTA',
                    comments: '',
                    date: '2022-04-29'
                },
                {
                    id: '2',
                    type: 'REFERENCIAS LABORALES',
                    comments: '',
                    date: null
                },
                {
                    id: '3',
                    type: 'PRUEBAS PSICOMÉTRICAS',
                    comments: '',
                    date: null
                },
                {
                    id: '4',
                    type: 'ESTUDIO SOCIOECONÓMICO',
                    comments: '',
                    date: null
                },
                {
                    id: '5',
                    type: 'SIN RESPUESTA',
                    comments: '',
                    date: null
                },
                {
                    id: '6',
                    type: 'CONTRATACION',
                    comments: '',
                    date: null
                }
            ]
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Candidates",	
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,	
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index()
        {
            this.loading = true;
            this.$store.state.loading = true;
			this.$api.jobs.getCandidate(this.jobId, this.candidateId)
			.then((response) => {
                this.form.status = response.data.status;
                this.form.name = response.data.name;
                this.form.step = response.data.current_status.type;

                console.log(this.form);
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
        },
		validate () {
			return this.$refs.form.validate()
		},
        save(){
            this.saveBtnData.loading = true;
            this.$store.state.loading = true;
           
            // this.$store.state.overlay = true
            
            if(this.validate()){
                
                
                const request = this.prepareRequest(this.form);
               
                
                this.$api.jobs.updateCandidateProcess(this.jobId, this.candidateId, request)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Candidates'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 400: 
                                //console.log(99, error.response);
                                if(("message" in error.response.data)){
                                    Object.keys(error.response.data.message).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.message;
                                        error.response.data.message[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                    console.log(this.serverErrors);
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                this.saveBtnData.loading = false;
                this.$store.state.loading = false;
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },

        prepareRequest(data)
        {
            let newData = JSON.parse(JSON.stringify(data));

            newData.current_status_id = data.status.find(itm => itm.type == data.step).id;
            delete newData.name;
            delete newData.step;
            return newData;
        }
    },
}
</script>

<style>

</style>